import React from 'react';
import { motion } from 'framer-motion';
import { FaSmileBeam, FaArrowUp, FaClock, FaChartLine, FaBullseye } from 'react-icons/fa';
import './Benefits.css';

const Benefits = () => {
  const benefits = [
    {
      icon: <FaChartLine />,
      title: 'Satışları Artırın',
      description: 'Satışlarınızı artırın, satış artışı yapın',
      stat: '%40'
    },
    {
      icon: <FaClock />,
      title: 'Zaman Tasarrufu',
      description: 'Otomasyon ile günlük işlerinizde zaman kazanın',
      stat: '5 Saat'
    },
    {
      icon: <FaArrowUp />,
      title: 'Verimlilik Artışı',
      description: 'Ekip verimliliğinizi ölçülebilir şekilde artırın',
      stat: '%60'
    },
    {
      icon: <FaSmileBeam />,
      title: 'Müşteri Memnuniyeti',
      description: 'Daha iyi müşteri hizmeti ile memnuniyeti artırın',
      stat: '%95'
    },
    {
      icon: <FaBullseye />,
      title: 'Hedef Odaklılık',
      description: 'Hedeflerinizi belirleyin, takip edin ve başarıya ulaşın',
      stat: '%80'
    }
  ];

  return (
    <section className="benefits section">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">İşletmenize Sağladığı Faydalar</h2>
          <p className="section-subtitle">
            FlowSky CRM ile işletmenizi bir üst seviyeye taşıyın
          </p>
        </motion.div>

        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              className="benefit-card"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ scale: 1.05 }}
            >
              <div className="benefit-icon">
                {benefit.icon}
              </div>
              <h3 className="benefit-title">{benefit.title}</h3>
              <p className="benefit-description">{benefit.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;

